import { IonIcon } from '@ionic/react';
import { chevronForwardCircleOutline, helpCircleOutline } from 'ionicons/icons';
import { NavLink } from 'react-router-dom';
import isElectron from '../../../utils/isElectron';
import PostHogService from '../../../services/PostHog.service';
import { config } from '../../../config';
import style from './build-selection.module.scss';

export default function BuildSelection() {
  const handleBuildMethodClick = (method: string) => {
    try {
      if (PostHogService.isInitialized()) {
        PostHogService.capture('build_method_selected', {
          build_method: method,
          is_electron: isElectron(),
          app_version: config.VERSION,
        });
      }
    } catch (error) {
      console.error('[BuildSelection] Error capturing PostHog event:', error);
    }
  };
  const buildCratePaths = [
    // { display: 'Home', link: 'home' },
    { display: 'Import from Spotify', link: 'spotify' },
    { display: 'Import from Curated Crates', link: 'curated' },
    { display: 'Import from Trending Crates', link: 'trending' },
    { display: 'Build from a Track', link: 'track' },
    { display: 'Import from Text', link: 'text' },
    { display: 'Import a File', link: 'file' },
    { display: 'Import from Serato', link: 'serato', platform: 'electron' },
    // { display: 'Start from a Genre', link: 'genre' },
    { display: 'Import from SMPL', link: 'smpl' },
    { display: 'Import from DJEP', link: 'djep' },
  ];
  return (
    <>
      {buildCratePaths
        // Disable serato path on web
        .filter((option) => !(option.platform === 'electron' && !isElectron()))
        .map((option, index) => (
          <NavLink
            to={
              option.link == 'curated'
                ? '/crates'
                : option.link == 'trending'
                  ? '/charts'
                  : `/my-crates/${option.link}`
            }
            activeClassName={style['crate-option-active']}
            className={`${style['crate-option']}`}
            key={index}
            onClick={() => handleBuildMethodClick(option.link)}
          >
            <div className={style['crate-option-text']}>{option.display}</div>
            <IonIcon
              className={style['crate-option-icon']}
              icon={
                option.link === 'home'
                  ? helpCircleOutline
                  : chevronForwardCircleOutline
              }
            />
          </NavLink>
        ))}
    </>
  );
}
